"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var _systemSetting = require("@/api/systemSetting");
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StatementPaymentDialog',
  data: function data() {
    return {
      visible: false,
      statementId: null,
      statementInfo: {},
      tableLoading: false,
      tableData: [],
      total: 0,
      pageParams: {
        page: 1,
        limit: 10
      },
      addDialogVisible: false,
      submitLoading: false,
      voucherUploading: false,
      form: {
        statementId: null,
        amount: null,
        paymentDate: '',
        feishuNo: '',
        voucher: '',
        fileName: '',
        remark: ''
      },
      formRules: {
        amount: [{
          required: true,
          message: '实际打款金额不能为空',
          trigger: 'blur'
        }],
        paymentDate: [{
          required: true,
          message: '打款日期不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.debouncedSubmit = (0, _validate.Debounce)(this.submitHandler, 500);
  },
  methods: {
    open: function open(row) {
      this.statementId = row.id;
      this.statementInfo = _objectSpread({}, row);
      this.pageParams = {
        page: 1,
        limit: 10
      };
      this.visible = true;
      this.loadList();
    },
    handleClosed: function handleClosed() {
      window.removeEventListener('paste', this.handlePaste);
      this.$emit('refresh');
      this.tableData = [];
      this.total = 0;
    },
    loadList: function loadList() {
      var _this = this;
      this.tableLoading = true;
      var params = _objectSpread({
        statementId: this.statementId
      }, this.pageParams);
      statementApi.statementPaymentListApi(params).then(function (data) {
        _this.tableData = data.list || [];
        _this.total = data.total || 0;
        _this.tableLoading = false;
      }).catch(function () {
        _this.tableLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.page = 1;
      this.loadList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageParams.page = val;
      this.loadList();
    },
    handleAdd: function handleAdd() {
      this.form = {
        statementId: this.statementId,
        amount: this.getDefaultPaymentAmount(),
        paymentDate: this.getCurrentDateTime(),
        feishuNo: '',
        voucher: '',
        fileName: '',
        remark: ''
      };
      this.addDialogVisible = true;
      window.removeEventListener('paste', this.handlePaste);
      window.addEventListener('paste', this.handlePaste);
    },
    getDefaultPaymentAmount: function getDefaultPaymentAmount() {
      var actualAmount = Number(this.statementInfo.actualAmount || 0);
      var actualSettlementFreightAmount = Number(this.statementInfo.actualSettlementFreightAmount || 0);
      var actualSettlementPackingFeeAmount = Number(this.statementInfo.actualSettlementPackingFeeAmount || 0);
      var settledPriceDifference = Number(this.statementInfo.settledPriceDifference || 0);
      return Number((actualAmount + actualSettlementFreightAmount + actualSettlementPackingFeeAmount + settledPriceDifference).toFixed(2));
    },
    getCurrentDateTime: function getCurrentDateTime() {
      var date = new Date();
      var pad = function pad(value) {
        return String(value).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    },
    triggerUpload: function triggerUpload() {
      this.$refs.fileInputRef.click();
    },
    handleFileChange: function handleFileChange(e) {
      var file = e.target.files[0];
      if (!file) return;
      this.uploadVoucherFile(file);
      e.target.value = '';
    },
    handlePaste: function handlePaste(event) {
      if (!this.addDialogVisible || this.voucherUploading) return;
      var items = event.clipboardData && event.clipboardData.items;
      if (!items) return;
      var imageItem = Array.prototype.find.call(items, function (item) {
        return item.type && item.type.indexOf('image/') === 0;
      });
      if (!imageItem) return;
      var blob = imageItem.getAsFile();
      if (!blob) return;
      event.preventDefault();
      var ext = blob.type === 'image/jpeg' ? 'jpg' : 'png';
      var file = new File([blob], "\u6253\u6B3E\u51ED\u8BC1-".concat(Date.now(), ".").concat(ext), {
        type: blob.type
      });
      this.uploadVoucherFile(file);
    },
    uploadVoucherFile: function uploadVoucherFile(file) {
      var _this2 = this;
      if (this.voucherUploading) return;
      this.voucherUploading = true;
      var formData = new FormData();
      formData.append('multipart', file);
      var isImage = /\.(png|jpe?g|gif|bmp|webp)$/i.test(file.name);
      var uploadApi = isImage ? _systemSetting.fileImageApi : _systemSetting.fileFileApi;
      var loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading'
      });
      uploadApi(formData, {
        model: this.$route.path.split('/')[1],
        pid: 10
      }).then(function (res) {
        loading.close();
        _this2.form.voucher = res.url;
        _this2.form.fileName = res.fileName || file.name;
        _this2.$message.success('上传成功');
      }).catch(function () {
        loading.close();
      }).finally(function () {
        _this2.voucherUploading = false;
      });
    },
    removeVoucher: function removeVoucher() {
      this.form.voucher = '';
      this.form.fileName = '';
    },
    handleAddDialogClosed: function handleAddDialogClosed() {
      window.removeEventListener('paste', this.handlePaste);
      this.voucherUploading = false;
    },
    submitHandler: function submitHandler() {
      var _this3 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        if (_this3.submitLoading) return;
        _this3.submitLoading = true;
        var data = _objectSpread({}, _this3.form);
        statementApi.statementPaymentAddApi(data).then(function () {
          _this3.$message.success('添加成功');
          _this3.addDialogVisible = false;
          _this3.loadList();
        }).catch(function () {}).finally(function () {
          _this3.submitLoading = false;
        });
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('确定删除该打款明细吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        statementApi.statementPaymentDeleteApi(row.id).then(function () {
          _this4.$message.success('删除成功');
          _this4.loadList();
        });
      }).catch(function () {});
    },
    formatAmount: function formatAmount(val) {
      return val != null ? Number(val).toFixed(2) : '0.00';
    },
    merchantTypeText: function merchantTypeText(val) {
      var m = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      return m[val] || '-';
    },
    getFileName: function getFileName(url) {
      if (!url) return 'download';
      var lastSlash = url.lastIndexOf('/');
      var filename = url.substring(lastSlash + 1);
      var queryIdx = filename.indexOf('?');
      return queryIdx > -1 ? filename.substring(0, queryIdx) : filename;
    },
    handleDownload: function handleDownload(row) {
      var url = row.voucher;
      if (!url) return;
      var a = document.createElement('a');
      a.href = url;
      a.download = this.getFileName(url);
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('paste', this.handlePaste);
  }
};